<template>
  <b-container class="py-4">
    <b-jumbotron class="text-center">
      <h1 class="display-3 mb-3">Error 404</h1>
      <p class="lead">Not found.</p>
      <hr />
      <b-button variant="primary" :to="{name: 'home'}">
        <i class="fas fa-home"></i>
        Back to homepage
      </b-button>
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {};
</script>

<style>
</style>
